import React, {useState, useEffect} from 'react';
import useUserContext from '../common/UserContext';

import { apiGet, getAccountsApiUrl, getAdminApiUrl, apiPatch } from '../common/AppApi';

import Processing from '../common/Processing';
import Pagination, { resetPaging } from '../common/Pagination';
import { formatPhone, cleanPhone, decodeValues } from '../common/Formats';
import { selectOptions } from '../common/Forms';
import { PageSize, PrivilegeCodes, StateArray } from '../common/Constants';
import MessageTag from '../common/MessageTag';
import Strings from '../common/Strings';

import AddRecipient from './AddRecipient';
import moment from 'moment';


export default function Applicants(props) {
	let {user} = useUserContext();
	let [programs, setPrograms] = useState([]);

	let [message, setMessage] = useState();
	let [showSpinner, setSpinner] = useState(false);
	let [dataRows, setDataRows] = useState([]);
	let [pagingData, setPagingData] = useState(resetPaging());

	let getPrograms = () => {
		let url = getAccountsApiUrl() + '/application/programs';

		setSpinner(true);
		apiGet(url).then((resp) => {
			let programs = [];
			resp.forEach( (p) => {
				programs.push({id:p.programId, text:p.programName, uuid:p.programUuid});
			});
			setPrograms(programs);

			setSearchForm({...searchForm, programId:programs[0].id});

		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	useEffect(() => {
		getPrograms();
	}, []);

	let handleFieldChange = (event) => {
		const {id, value} = event.target;
		setSearchForm({...searchForm, [id]:value});
	}

	let emptyForm = {
		firstname:'',
		lastname:'',
		email:'',
		mobilePhone:'',
		programId:''
	};
	let [searchForm, setSearchForm] = useState(emptyForm);

	let disableSearch = () => {
		for(const searchField in searchForm){
			if(searchForm[searchField])
				return false;
		}
		return true;
	};

	let searchApplicants = (e) => {
		e.preventDefault();

		setSpinner(true);

		let url = getAccountsApiUrl() + '/applicant';

		let queryParams = [];
		for(const searchField in searchForm) {
			if(searchField == 'mobilePhone') {
				queryParams.push(searchField + '=' + cleanPhone(searchForm[searchField]));
			} else {
				queryParams.push(searchField + '=' + encodeURIComponent(searchForm[searchField]));
			}
		}
		//TODO use backend paging?
		//queryParams.push('pageSize=10');
		if(queryParams.length)
			url = url + '?' + queryParams.join('&');

		apiGet(url).then((resp) => {
			//console.debug(resp);
			if (resp && resp.length) {
				setDataRows(resp);
				setMessage(null);
			} else {
				setDataRows([]);
				setMessage({text:'No applicants found.', type:'warning'});
			}
			setPagingData(resetPaging());
		}).catch( (err) => {
			console.error(err);
		}).finally( () => setSpinner(false) );
	};

	let [applicant, setApplicant] = useState({});

	let ShowApplicants = () => {
		if (dataRows && dataRows.length) {

			let addressOut = (addr2) => { return (addr2 ? <><br/>{addr2}</> : null); };

			let setupApplicant = (item) => {
				let appl = {...item};
				appl.stateCode = decodeValues(item.stateId, StateArray, 'id2', 'id');
				appl.programUuid = decodeValues(item.programId, programs, null, 'uuid');
				//console.debug(appl);
				setApplicant(appl);
			};

			const TableRow = (data) => {
				let item = data.row;
				let createdDate = moment(item.createdDate).format('YYYY-MM-DD HH:mm');
				let btnId = 'btn' + item.applicantId;

				return <tr key={item.applicantId}>
					<td>{item.firstname} {item.middlename} {item.lastname}</td>
					<td>{item.address1}{ addressOut(item.address2) }<br/>{item.city} {decodeValues(item.stateId, StateArray, 'id2')} {item.zipcode}</td>
					<td>{item.email}</td>
					<td>{formatPhone(item.mobilePhone)}</td>
					<td>{createdDate}</td>
					<td><button type='button' id={btnId} className='btn btn-primary btn-sm' onClick={ () => setupApplicant(item) }>Process</button></td>
				</tr>
			};

			let tableRows = dataRows.map( (data, index) => {
				return ( (index >= pagingData.beginIndex) && (index < (pagingData.beginIndex + PageSize)) ) ? <TableRow key={index} row={data} /> : null;
			});

			return <>
			<br/>
			<table className='table'>
				<thead>
					<tr><th>Name</th><th>Address</th><th>Email</th><th>Mobile Phone</th><th>Created</th><th></th></tr>
				</thead>
				<tbody>
					{ tableRows }
				</tbody>
			</table>

			<Pagination recordCount={dataRows.length} pagingData={pagingData} setPagingData={setPagingData} pageSize={PageSize} />

			</>;
		} else {
			return null;
		}
	};

	let divStyle = {
		width:'65rem', height:'47rem',
		margin: 'auto',
		position: 'fixed',
		top: 0, left: 0, bottom: 0, right: 0,
		zIndex: 100,
		overflowY:'scroll'
	};

	let cancelFunction = () => {
		setApplicant({});
	};

	let successFunction = () => {
		setApplicant({});
		let e = {preventDefault: () => console.log('search applicants') };
		searchApplicants(e);
	};

	let ProcessApplicant = (props) => {
		if (props.show) {
			return <div style={divStyle} id="addApplicant">
				<div className="card border-primary m-0">
					<div className="card-body">
						<AddRecipient cancelFunc={cancelFunction} applicant={applicant} successFunc={successFunction}/>
					</div>
				</div>
			</div>
		} else {
			return null;
		}
	};

	return (
		<>
		<h3>Applicants</h3>

		<MessageTag message={message} />
		<Processing show={showSpinner}/>

		<form onSubmit={searchApplicants}>
			<div className="row">
				<div className="form-group col-12 col-md-6 col-lg-3">
					<label htmlFor="programId">Program</label>
					<select id="programId" className="form-control custom-select" value={searchForm.programId} onChange={handleFieldChange} >
						{ selectOptions(programs) }
					</select>
				</div>
				<div className="form-group col-12 col-md-6 col-lg-3">
					<label htmlFor="firstname">First Name</label>
					<input type="text" id="firstname" className="form-control" onChange={handleFieldChange} value={searchForm.firstname} maxLength="100" />
				</div>
				<div className="form-group col-12 col-md-6 col-lg-3">
					<label htmlFor="lastname">Last Name</label>
					<input type="text" id="lastname" className="form-control" onChange={handleFieldChange} value={searchForm.lastname} maxLength="100" />
				</div>
			</div>
			<div className='row'>
				<div className="form-group col-12 col-md-6 col-lg-3">
					<label htmlFor="email">Email</label>
					<input type="text" id="email" className="form-control" onChange={handleFieldChange} value={searchForm.email} maxLength="255" />
				</div>
				<div className="form-group col-12 col-md-6 col-lg-3">
					<label htmlFor="mobilePhone">Phone</label>
					<input type="text" id="mobilePhone" className="form-control" onChange={handleFieldChange} value={searchForm.mobilePhone} maxLength="20" />
				</div>
			</div>
			<button className="btn btn-primary" disabled={false} title={Strings.warning.searchCritera} id="btnSearch">Search</button>
		</form>

		<ShowApplicants />

		<ProcessApplicant show={applicant.applicantId ? true : false}/>

		</>
	);
	
}
